import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Wallet } from "lucide-react";
import { WaveTopupButton } from "./WaveTopupButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Solde crédits WÔMA (clients, livreurs/chauffeurs) + recharge Wave
export const WalletWaveCard = ({ user }) => {
  const [balance, setBalance] = useState(null);
  const load = useCallback(() => {
    axios.get(`${API}/credits/balance/${user.id}`).then((r) => setBalance(r.data.credit_balance ?? r.data.balance ?? 0)).catch(() => {});
  }, [user?.id]);
  useEffect(() => { if (user?.id) load(); }, [load, user?.id]);

  return (
    <section className="flex items-center justify-between gap-4 flex-wrap bg-[#0F172A] border border-[#1DC8FF]/30 rounded-[2rem] p-5" data-testid="wallet-wave-card">
      <div>
        <p className="text-[10px] font-black uppercase tracking-[0.3em] text-[#1DC8FF] flex items-center gap-2"><Wallet size={14} /> Mon portefeuille WÔMA</p>
        <p className="text-2xl md:text-3xl font-black text-white mt-1" data-testid="wallet-wave-balance">
          {balance === null ? "…" : `${new Intl.NumberFormat("fr-FR").format(balance)} FCFA`}
        </p>
      </div>
      <WaveTopupButton user={user} onDone={load} />
    </section>
  );
};
